import React from "react";
import "../styles/footer.css";

export const Footer = () => {
  return (
    <>
      <div className="footer-main">
        <div className="cta-narrow">
          <div className="group">
            <h1 className="title roboto-bold-black-32px">
              Ready to get started?
            </h1>
            <div className="title roboto-normal-black-32px">
              Sign up or contact us
            </div>
          </div>
          <div className="sign-up-1">
            <div className="sign-up valign-text-middle roboto-normal-white-18px">
              Sign Up Here
            </div>
          </div>
          <div className="contact-us border-className-1">
            <div className="contact-us-1 valign-text-middle roboto-normal-black-18px">
              Contact Us
            </div>
          </div>
        </div>
        <div class="footer-full">
          <div class="flex-col">
            <div class="logo-1 roboto-bold-black-24px">TRADE</div>
            <div class="copyright roboto-normal-black-14px">© 2010 — 2020</div>
            <div class="link-6 roboto-normal-black-14px">Privacy — Terms</div>
          </div>
        </div>
      </div>
    </>
  );
};
